import React from 'react';

interface TextAreaProps
    extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
    label?: string;
}

const TextArea: React.FC<TextAreaProps> = (props) => {
    const { label, className, id } = props;
    return (
        <div className="form-group">
            {props.label && <label htmlFor={id}>{label}</label>}
            <textarea {...props} className={`form-control ${className}`} />
        </div>
    );
};

export default TextArea;
